export enum GlazingBeadLocation {
  DoorSide = 'Door Side',
  CenterGlazed = 'Center Glazed',
  OppositeDoorSide = 'Opposite Door Side',
}
